import { render, staticRenderFns } from "./ManagerRating.vue?vue&type=template&id=a20c147a&scoped=true"
import script from "./ManagerRating.vue?vue&type=script&lang=js"
export * from "./ManagerRating.vue?vue&type=script&lang=js"
import style0 from "./ManagerRating.vue?vue&type=style&index=0&id=a20c147a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20c147a",
  null
  
)

export default component.exports